import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgSendToMany({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 26 26"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path d="M4.387 4.333H16.44c.828 0 1.506.678 1.506 1.507V8.1c-.376.377-1.883 2.26-3.39 4.143-1.506 1.883-3.013 3.766-3.39 4.143H5.895l-2.371 2.371a.376.376 0 0 1-.643-.266V5.84c0-.829.678-1.507 1.507-1.507Zm16.972 3.334 1.332 1.027c.56.432.672.932.35 1.336l-.895 1.123-3.085-2.378.896-1.124c.32-.402.842-.415 1.402.016Zm-3.48 2.591 3.085 2.378-5.864 7.357-.057.06c-.082.071-.301.114-.301.114l-2.44.726a.298.298 0 0 1-.383-.286l.01-2.608c-.01-.265-.002-.276.067-.36l.021-.026 5.862-7.355Z" />
        </svg>
    )
}
SvgSendToMany.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgSendToMany
